import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import IndexCard from "../../../shared/IndexCard/IndexCard";
import { Link, useOutletContext } from "react-router-dom";

const JobListPage = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const openJobs = jobs;

  // 希望条件の有無（jobExists）と
  // 公開・非公開ステータス（isActive）を ProjectLayout から受け取る
  const { jobExists, isActive } = useOutletContext();

  const fetchJobs = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch("/jobs.json", {
        credentials: "same-origin",
        cache: "no-store",
      });
      if (!res.ok) {
        const text = await res.text();
        console.error("jobs.json error", res.status, text);
        if (res.status === 403) {
          setJobs([]);
        } else {
          setJobs([]);
        }
        return;
      }
      const data = await res.json();
      setJobs(data);
    } catch (err) {
      console.error("fetchJobs failed:", err);
      setJobs([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchJobs();
    const onFocus = () => fetchJobs();
    const onVisibility = () =>
      document.visibilityState === "visible" && fetchJobs();
    const onPageShow = (e) => e.persisted && fetchJobs();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pageshow", onPageShow);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pageshow", onPageShow);
    };
  }, [fetchJobs]);

  const handleMarkedRead = useCallback((jobId) => {
    setJobs((prev) =>
      prev.map((j) => (j.id === jobId ? { ...j, read_flag: true } : j))
    );
  }, []);

  return (
    <>
      <Box sx={{ maxWidth: 960, mx: "auto", mb: 10 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : openJobs.length === 0 ? (
          <Typography color="text.secondary" sx={{ mt: 4 }}>
            現在、公開中の求人はありません。
            <br />
            お問い合わせ内容をもとに、条件に合う求人をご案内できる場合があります。
            <br />
            お問い合わせフォームよりお気軽にご連絡ください。
          </Typography>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: { xs: 1, sm: 2 },
            }}
          >
            {openJobs.map((job) => (
              <IndexCard
                key={job.id}
                item={job}
                type="job"
                component={Link}
                to={`/jobs/${job.id}`} // ユーザー向け詳細ページへ
                onMarkedRead={handleMarkedRead}
                contractExists={jobExists}
                isActive={isActive}
              />
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};

export default JobListPage;
